import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import { FetchAdButlerRequestDto, FetchAdButlerResponseDto } from './types';

export function fetchAdButlerAds(
  url: string,
  payload: FetchAdButlerRequestDto,
) {
  return fetchBasedCall<FetchAdButlerRequestDto, FetchAdButlerResponseDto>({
    url: `${url}/adserve/`,
    method: 'POST',
    body: payload,
    schemas: {
      response: FetchAdButlerResponseDto,
      request: FetchAdButlerRequestDto,
    },
  });
}
